export default __webpack_public_path__ + "static/media/Background_00249.ff0dcc11.png";